export class CartBreakdown {
    netAmount = 0;
    grossAmount = 0;
    tip = 0;
    total = 0;
    subtotal = 0;
    vat = 0;
    deliveryCosts = 0;
    deliveryZoneId = null;
    deliveryTimeNeeded = null;
    weight = null;
    vatByRate = {};
    appliedDiscounts = [];
    items = {};
    tipIsTaxed = false; //we need to know this because it changes the ordering of the others        
    getVatRatesInfo() {
        let infos = [];
        for (let vatRate in this.vatByRate) {
            let amount = Number.parseFloat('' + this.vatByRate[vatRate]);
            let base = amount / Number.parseFloat(vatRate) * 100;
            let total = (base + amount);
            infos.push({
                rate: vatRate,
                amount: amount.toFixed(2),
                base: Number.parseFloat('' + base).toFixed(2),
                total: total.toFixed(2)
            });
        }
        return infos;
    }
    constructor(data) {
        if (data) {
            let definedKeys = Object.keys(this);
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
